<div class="up-row">
    <img src="assets/imgs/upcome.svg">
    <span class="message">This Feature will be Available in Our Next Version </span>
</div>